var _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 84,
    viewBox: "0 0 85 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M74.0027 42.0859C74.0027 59.3017 59.9541 73.2578 42.6244 73.2578C25.2946 73.2578 11.2461 59.3017 11.2461 42.0859C11.2461 24.8702 25.2946 10.9141 42.6244 10.9141C59.9541 10.9141 74.0027 24.8702 74.0027 42.0859Z",
    fill: "black",
    fillOpacity: 0.35,
    stroke: "#63DAA5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.3123 41.2522L37.2045 29.2598C36.5398 28.8195 35.6523 29.2962 35.6523 30.0935V54.0784C35.6523 54.8758 36.5398 55.3524 37.2045 54.9122L55.3123 42.9197C55.9094 42.5243 55.9094 41.6477 55.3123 41.2522Z",
    fill: "url(#paint0_linear_3332_2658)",
    fillOpacity: 0.75
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3332_2658",
    x1: 24.9878,
    y1: 36.3813,
    x2: 62.1335,
    y2: 64.7332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFFF92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#33F3FF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.44f6c905d817af2537393e3b909db8b4.svg";
export { ForwardRef as ReactComponent };